
// Helper functions

function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
        if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
        ) {
            clearInterval(interval);
            trigger();
        }
    }, delayInterval);
    setTimeout(function () {
        clearInterval(interval);
    }, delayTimeout);
}

// Actions

//console.log('test');

var simulateClick = function (elem) {
  var evt = new MouseEvent('click', {
  bubbles: true,
  cancelable: true,
  view: window
  });
var canceled = !elem.dispatchEvent(evt);
};

function startQuiz() {
  var sq = document.querySelector('#quiz-kit-intro-button');
  simulateClick(sq);
}

//waitForElement("#quiz-kit-intro-button", startQuiz, 50, 15000);
function hideReviewSection(){
  if(document.querySelector(".junip-no-reviews")){
    document.querySelector("#pdp-junip-reviews").style.display="none";
  }
}
waitForElement(".junip-no-reviews", hideReviewSection, 50, 15000);
function updateReviewWidget(){
  if(document.querySelector('div[data-sticky-atc]')){
    if(document.querySelector('div[data-sticky-atc]').classList.contains("active")){
      document.getElementById("smile-ui-lite-launcher-frame-container").style.bottom="90px";
    }
  }
}
function loadSlider(){
  
}
let rechargeTimerHandler;
jQuery(document).ready(function($){
  let customSweiper;
  if($(".blog-promot-product-slider").length > 0){
    new IntersectionObserver(function (e) {
      if(e[0].isIntersecting){
        $(".blog-page-footer-section-custom").removeClass("active");
      }else{
        $(".blog-page-footer-section-custom").addClass("active");
        customSweiper.update();
      }
    }).observe(document.querySelector("article.article"))
    const totalSLide = $(".blog-promot-product-slider").data('count');
    let displaySlide = 5;
    if(totalSLide < 5){
      displaySlide = totalSLide
    }
     customSweiper = new Swiper('.blog-promot-product-slider', {
       observer: true,
            observeParents: true,
        loop: totalSLide > 1,
        slidesPerView: displaySlide,
        paginationClickable: false,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: displaySlide,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: (totalSLide < 5) ? displaySlide : 3 ,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });
  }
  $(document).on("click",".custom-recharge-update",function(){
    const keyId = $(this).data('key');
    const parentElement = $(this).parents(".custom-recharge-wrapper");
    const subscriptionType = parentElement.find(".rc-option.rc_widget__option input:checked").val();
    let selling_plan_id = null;
    const variant_id = parentElement.find('.custom-v-selector').val();
    if(subscriptionType == 'subsave'){
      selling_plan_id = parentElement.find(".rc_widget__option__plans__dropdown").val();
    }
    let formData = {
      'id': keyId,
      'selling_plan': selling_plan_id
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then( data => {
      window.location.reload();
      //window.CartDrawer.fetchCart();
        //window.CartDrawer.open()
    })
    .catch((error) => {
       
    });
   
  });
$(document).on("click",".cart-item__remove-custom",function(e){
    e.preventDefault();
    const keyId = $(this).data('key');
    let formData = {
      'id': keyId,
      'quantity': 0
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then( data => {
        window.CartDrawer.fetchCart();
        //window.CartDrawer.open()
    })
    .catch((error) => {
       
    });
  });
  $(document).on("click",".custom-add-to-cart",function(){
   
    const variant_id = $(this).data('id');
    const isrequedPlan = $(this).data('subscriotion');
     const selling_plan = $(this).data('planid');
    let formData = {
     'items': [{
      'id': variant_id,
      'quantity': 1,
       'selling_plan': (isrequedPlan ? selling_plan : '')
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then( data => {
      if($('body').hasClass('template-cart')){
         window.location.reload();
      }else{
        window.CartDrawer.fetchCart();
        window.CartDrawer.open()
      }
     
    }).catch((error) => {
      console.error('Error:', error);
    });
  });

      $(document).on("change",".rc_widget__option__input",function(){
        const parentElement = $(this).parent(".rc_widget__option__selector");
        const customPrice = parentElement.find(".rc-option__price").text().replace("$","");
        if(document.querySelector('afterpay-placement') != null ){
         document.querySelector('afterpay-placement').setAttribute('data-amount', customPrice);
        }
      });

    rechargeTimerHandler = setInterval(function(){
      if($(".rc_widget__option__input").length > 0){
        const parentElement = $(".rc_widget__option__input:checked").parent(".rc_widget__option__selector");
        const customPrice = parentElement.find(".rc-option__price").text().replace("$","");
        if(document.querySelector('afterpay-placement') != null ){
         document.querySelector('afterpay-placement').setAttribute('data-amount', customPrice);
        }
        //rcSetCrossedPrice();
        clearInterval(rechargeTimerHandler);
      }
    },500);
});

const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');

     const customPureSrc = event.target.src.split('?')[0].replace(/http(s)?:/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[customPureSrc] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[customPureSrc][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('[class*=single-option-selector]');
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              //selects[index].dispatchEvent(new Event('change'));
               $(`.product-option__value input[value="${optionValue}"]`).prop("checked",true).trigger('click');
              break;
            }
          }
        }
      });
    }
  },
  _updateVariantImage:function(event, id, product, variantImages){
    const selectedOptionValue = event.target.value;
    const imageCarousel = jQuery ( '.product__gallery.swiper' );
    const swiperObject = imageCarousel[0].swiper;
    const thumbnails = document.querySelectorAll('.product__gallery img');
    thumbnails.forEach((thumbnail,slideIndex) => {
      const arrImage = thumbnail.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
       const customPureSrc = thumbnail.src.split('?')[0].replace(/http(s)?:/, '');
      const strExtention = arrImage.pop();
      const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
      const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
      if (typeof variantImages[customPureSrc] !== 'undefined') {
        product.variants.forEach((option, index) => {
          const optionValue = variantImages[customPureSrc][`option-${index}`];
          if (optionValue !== null && optionValue !== undefined) {
            if (selectedOptionValue === optionValue) {
              swiperObject.slideTo(slideIndex);
            }
          }
        });
      }
    });
  },  
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[data-product-json]');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = "";
        const thumbnails = document.querySelectorAll('.product__thumbs img');
        const optionSelectors = document.querySelectorAll(".product-option__values input[data-product-option]");
        const stickyOptionSelectors = document.querySelectorAll(".sticky-atc-option__values input[data-product-option]");
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
         
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages),
              );
            });
            if(optionSelectors.length > 0){
              optionSelectors.forEach((option) => {
                option.addEventListener('click', (e) =>
                  this._updateVariantImage(e, sectionId, productObject, variantImages),
                );
              });
            }
            if(stickyOptionSelectors.length > 0){
              stickyOptionSelectors.forEach((option) => {
                option.addEventListener('click', (e) =>
                  this._updateVariantImage(e, sectionId, productObject, variantImages),
                );
              });
            }
            
          }
        }
      });
    }
  }  
};
jQuery(document).ready(function(){
   selectVariantByClickingImage._selectVariant();
});
// Add crossed out price for free product
//console.log('mutobs');
let customTimerInterval;
if(document.title.indexOf('Condoms') > -1) {
  setInterval(function () {
    if(document.querySelector('.standard-price')){
      if(document.querySelector('.recharge-inner-most-price') && document.querySelector('.recharge-inner-most-price').textContent == '$0') {
        if(!document.querySelector('.standard-price').classList.contains('show')) {
          document.querySelector('.standard-price').classList.add('show');
        }
      } else {
        if(document.querySelector('.standard-price').classList.contains('show')) {
          document.querySelector('.standard-price').classList.remove('show');
        }
      }
      //clearInterval(customTimerInterval);
    }
    
  }, 500);
}
const rcSetCrossedPrice = () =>{
  const targetElement = document.querySelector('.rc-option__subsave .rc_widget__option__label');
  // Create a new MutationObserver instance
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      console.log(mutation.target,mutation.target.classList.contains("rc_widget__price--subsave"));
      if(mutation.target.classList.contains("rc_widget__price--subsave")){
        const discountedPrice = mutation.target.text().replace(/[^A-Z0-9]/ig, "");
        console.log(discountedPrice,"discountedPrice");
        if(mutation.target.parentElement.querySelectorAll("span.crossed-price").length > 0){
          
        }else{
          
        }
      }
      
    });
  });
  
  // Configure the observer
  const observerConfig = {
    attributes: false,            // Observe attribute changes
    childList: true,             // Observe additions/removals of child nodes
    subtree: false               // Observe all descendants of the target node
   // attributeFilter: ['class'],  // Optionally filter observed attributes
  };
  
  // Start observing the target element
  observer.observe(targetElement, observerConfig);
}          
